import { z } from 'zod';
import { ConversationOutcomeSchema } from './conversation.js';

export const MetricsOverviewSchema = z.object({
  totalConversations: z.number().int(),
  byTopic: z.array(
    z.object({
      topicId: z.string(),
      topicName: z.string(),
      count: z.number().int(),
    }),
  ),
  byOutcome: z.array(
    z.object({
      outcome: ConversationOutcomeSchema.nullable(),
      count: z.number().int(),
    }),
  ),
  byRep: z.array(
    z.object({
      repId: z.string(),
      repName: z.string(),
      count: z.number().int(),
    }),
  ),
});
export type MetricsOverview = z.infer<typeof MetricsOverviewSchema>;

export const DraftUsageMetricsSchema = z.object({
  totalDrafts: z.number().int(),
  usedAsIs: z.number().int(),
  usedWithEdits: z.number().int(),
  ignored: z.number().int(),
});
export type DraftUsageMetrics = z.infer<typeof DraftUsageMetricsSchema>;

export const ResponseTimeMetricsSchema = z.object({
  averageSeconds: z.number().nullable(),
  sampleSize: z.number().int(),
});
export type ResponseTimeMetrics = z.infer<typeof ResponseTimeMetricsSchema>;
